export default __webpack_public_path__ + "static/media/features-pic-x2.c250a8d4.png";